import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { IoMdClose } from "react-icons/io";
import { showIconByServiceId } from "../../../helper/showIconByServiceId";
import jsPDF from "jspdf";
import "jspdf-autotable";
import StatusChanger from "../edit/status-chenger";
import { FaEye, FaFileExcel } from "react-icons/fa";
import { Link } from "react-router-dom";
import PaymentStatusChanger from "../edit/status-chenger/PaymentStatusChanger";
import { ability } from "../../../config/acl/ability";
import * as XLSX from 'xlsx';
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import {Can} from "../../Can";


const DataTableAllOrder = ({ data, setData, rowsPerPage, currentPage,setOrderOption,filters }) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const canReviewOrder = ability.can('order', 'review');

  const [exportLoading, setExportLoading] = useState(false);

  // Handle sorting logic
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...data].sort((a, b) => {
    if (!orderBy) return 0;
    if (a[orderBy] === null || b[orderBy] === null) return 0; // Null-safe comparison
    if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
    return 0;
  });

  // Export PDF
  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("services Table", 14, 10);
    doc.autoTable({
      startY: 20,
      head: [
        [
          "ID",
          "Service",
          "Service Type",
          "User Name",
          "Reseller",
          "Price",
          "Panel URL",
          "Payment Method",
          "Created At",
          "Status Payment",
          "Status",
        ],
      ],
      body: sortedData.map((item) => [
        item.request_id,
        item.our_service || "N/A",
        item.our_service_type || "N/A",
        item.user_name || "N/A",
        item.reseller || "N/A",
        item.price || "N/A",
        item.panel_url || "N/A",
        item.payment_method || "N/A",
        item.created_at || "N/A",
        item.status_payment || "N/A",
        item.status || "N/A",
      ]),
    });
    doc.save("ServicesTable.pdf");
  };

  const exportToExcel = async () => {
    setExportLoading(true);
    try {
      // Build query string from filters (same as parent component)
      const queryParams = [];
      if (filters.dateRange.start && filters.dateRange.end) {
        queryParams.push(`start_date=${filters.dateRange.start.toISOString().split("T")[0]}`);
        queryParams.push(`end_date=${filters.dateRange.end.toISOString().split("T")[0]}`);
      } else if (filters.dateRange.end) {
        queryParams.push(`end_date=${filters.dateRange.end.toISOString().split("T")[0]}`);
      }
      if (filters.orderStatus && filters.orderStatus !== "null") {
        queryParams.push(`order_status=${filters.orderStatus}`);
      }
      if (filters.paymentStatus && filters.paymentStatus !== "null") {
        queryParams.push(`payment_status=${filters.paymentStatus}`);
      }
      if (filters.source && filters.source !== "null") {
        queryParams.push(`source=${filters.source}`);
      }
      if (filters.panelUrl) {
        queryParams.push(`panel_url=${encodeURIComponent(filters.panelUrl)}`);
      }

      const queryString = queryParams.length ? `${queryParams.join("&")}` : "";
      const url = `${api_Routes.Orders.ExportAll}?${queryString}`;

      const { response, message } = await Helper.Get({
        url,
        hasToken: true,
      });

      if (response) {
        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(
            response.data.map(item => ({
              ID: item.request_id,
              Service: item.our_service || "N/A",
              'Service Type': item.our_service_type || "N/A",
              'User Name': item.user_name || "N/A",
              Reseller: item.reseller || "N/A",
              Price: item.price || "N/A",
              Created_By: item.created_By || "N/A",
              Discount: item.discount_type !== 'none' && (item.discount_for_auto_pay || item.discount_type === 'percentage')
                  ? (item.discount * item.price / 100) + (item.discount_for_auto_pay * item.price / 100)
                  : item.discount || 0,
              "Net Price": item.discount_type !== 'none' && (item.discount_for_auto_pay || item.discount_type === 'percentage')
                  ? item.price -(item.discount * item.price / 100) + (item.discount_for_auto_pay * item.price / 100)
                  : item.price -item.discount || 0,
              'Panel URL': item.panel_url || "N/A",
              'Payment Method': item.payment_method || "N/A",
              'Created At': item.created_at || "N/A",
              'Payment Status': item.status_payment || "N/A",
              Status: item.status || "N/A",
            }))
        );

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

        // Export file
        XLSX.writeFile(workbook, `Orders_Export_${new Date().toISOString().split('T')[0]}.xlsx`);
      } else {
        throw new Error(message || 'Failed to export data');
      }

    } catch (error) {
      console.error('Export error:', error);
      alert('Failed to export data. Please try again.');
    } finally {
      setExportLoading(false);
    }
  };


  return (
    <>
      <div className="flex gap-2 mb-3">
        {/*<button*/}
        {/*    onClick={exportPDF}*/}
        {/*    className="bg-primary text-white p-2 rounded flex items-center gap-2"*/}
        {/*>*/}
        {/*  Export to PDF*/}
        {/*</button>*/}
        <Can I={'export'} a={'orders'}>
          <button
              onClick={exportToExcel}
              disabled={exportLoading}
              className="bg-green-600 text-white p-2 rounded flex items-center gap-2 disabled:opacity-50"
          >
            <FaFileExcel />
            {exportLoading ? 'Exporting...' : 'Export to Excel'}
          </button>
        </Can>

      </div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow className="bg-primary">
              {[
                { label: "ID", key: "request_id" },
                { label: "Service", key: "our_service" },
                { label: "Service Type", key: "our_service_type" },
                { label: "User Name", key: "user_name" },
                { label: "Reseller", key: "reseller" },
                { label: "Price", key: "price" },
                { label: "Discount", key: "discount" },
                { label: "Net Price", key: "price" },
                { label: "Panel URL", key: null },
                { label: "Created At", key: "created_at" },
                { label: "Created By", key: "created_By" },
                { label: "Status Payment", key: "status_payment" },
                { label: "Status", key: "status" },
                { label: "Action", key: "action" },
                // canReviewOrder ?{ label: "Review", key: "review" } : {},
              ].map((column) => (
                <TableCell
                  align="center"
                  className="!text-darkTextColor whitespace-nowrap"
                  key={column.label}
                  onClick={
                    column.key ? () => handleSort(column.key) : undefined
                  }
                  style={{ cursor: column.key ? "pointer" : "default" }}
                >
                  {column.label}
                  {column.key &&
                    (orderBy === column.key ? (
                      order === "asc" ? (
                        <span> ▲</span>
                      ) : (
                        <span> ▼</span>
                      )
                    ) : (
                      ""
                    ))}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.map((item) => (
              <TableRow
                key={item.request_id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="center">{item?.request_id}</TableCell>
                <TableCell align="center">
                  {item?.our_service || <IoMdClose style={{ color: "red" }} />}
                </TableCell>
                <TableCell align="center">
                  {item?.our_service_type || `Custom Order : ${item.count} (Tickets | Messages | Days)`}
                </TableCell>
                <TableCell align="center">{item?.user_name}</TableCell>
                <TableCell align="center">{item?.reseller}</TableCell>
                <TableCell align="center">{item?.price}</TableCell>
                <TableCell align="center">
                  {item?.discount_type != 'none' && (item?.discount_for_auto_pay || item?.discount_type === 'percentage') ?

                  (item?.discount * item?.price / 100) +  (item?.discount_for_auto_pay * item?.price / 100):
                      item?.discount ?? 0
                  }
                </TableCell>
                <TableCell align="center">
                  {item?.discount_type != 'none' && (item?.discount_for_auto_pay || item?.discount_type === 'percentage') ?

                      item?.price - (item?.discount * item?.price / 100) +  (item?.discount_for_auto_pay * item?.price / 100):
                      item?.price -item?.discount ?? 0
                  }
                </TableCell>
                <TableCell align="center">
                  <a
                    className="inline-block w-full max-w-48 truncate"
                    href={item?.panel_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item?.panel_url}
                  </a>
                </TableCell>
                <TableCell align="center">{item?.created_at}</TableCell>
                <TableCell align="center">{item?.created_By}</TableCell>
                <TableCell align="center">
                    <span
                        className={`badge w-24 text-darkTextColor ${
                            item?.status_payment === "paid"
                                ? "bg-[#28a745]"
                                : item?.status_payment === "pending"
                                ? "bg-[#f7cb73]"
                                : "bg-[#ff6877]"
                        }`}
                    >
                      {item?.status_payment}
                    </span>
                </TableCell>
                {/*{(item?.payment_method === "manually" && canReviewOrder) &&*/}
                {/*item?.status_payment === "pending" ? (*/}
                {/*  <TableCell align="center">*/}
                {/*    <PaymentStatusChanger*/}
                {/*      data={item}*/}
                {/*      setData={setData}*/}
                {/*      rowsPerPage={rowsPerPage}*/}
                {/*      currentPage={currentPage}*/}
                {/*    />*/}
                {/*  </TableCell>*/}
                {/*) : (*/}
                {/*  */}
                {/*)}*/}
                <TableCell align="center">
                  <StatusChanger
                    data={item}
                    setData={setData}
                    rowsPerPage={rowsPerPage}
                    currentPage={currentPage}
                    setOrderOption={setOrderOption}
                  />
                </TableCell>
                <TableCell align="center">
                  <Link
                    to={`/Orders/${item?.uuid}`}
                    color="inherit"
                    underline="none"
                  >
                    <FaEye className="text-[#6c757d]" />
                  </Link>
                </TableCell>
                {/*{canReviewOrder &&*/}
                {/*<TableCell align="center">*/}
                {/*  {item.our_service_id ?*/}
                {/*      <Link*/}
                {/*          to={`/Orders-review/${item?.uuid}`}*/}
                {/*          color="inherit"*/}
                {/*          underline="none"*/}
                {/*      >*/}
                {/*        <FaEye className="text-[#6c757d]"/>*/}
                {/*      </Link> :*/}
                {/*      <Link*/}
                {/*          to={`/customoffer-review/${item?.uuid}`}*/}
                {/*          color="inherit"*/}
                {/*          underline="none"*/}
                {/*      >*/}
                {/*        <FaEye className="text-[#6c757d]" />*/}
                {/*      </Link>*/}
                {/*  }*/}
                {/*</TableCell>*/}
                {/*}*/}

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default DataTableAllOrder;
